// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"cec94f6c","161":"2ea8e019","162":"04d984c3","164":"f913c69e","188":"af8c9f43","224":"ab90a683","258":"ee5597a4","399":"33143cc1","472":"323e01c4","513":"57c45889","705":"796fea2f","827":"7a5e6bf8","864":"fc496951","886":"b1763341","921":"dc8da5a1"}[chunkId] + ".chunk.js";
};